import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { formatPrice, getFinanceWeekly, getLeaseBiWeeklyFromMsrp } from '../../../utils';
import SummaryCalculator from '../../../Helpers/summarycalculator';
import { SummaryConstants as Constants } from '../../../Helpers/summaryconstants';
import { useTranslation } from "react-i18next";

export const EngineCard = ({ Model, Selected, HandleSelectedModel, Index, showFinancePrice, ...props }) => {
    const summaryCalculator = window.summaryCalculator;
    const [modelData] = React.useState(Model);
	const financial = JSON.parse(sessionStorage.getItem(Constants.FinancialObj));
    const engineCost = modelData.financial.msrp - summaryCalculator.SelectedTrim.financial.msrp; //financial.msrp;
    const { t, i18n } = useTranslation(['options', 'general']);
	const [expandedIndex, setExpandedIndex] = React.useState(null);
	const collapseRef = useRef(null);
	const [toggle, setToggle] = React.useState(false);
	const isExpanded = false;

    function setSelectedModel(index) {
        HandleSelectedModel(index)
    }

	useEffect(() =>{
		if(typeof window.mzAnimator === 'object'){
			window.mzAnimator.animateHeight(collapseRef.current, 'EngineCollapse' + Index, 'init')
		}
   	},[]);
   
    useEffect(() =>{
		window.mzAnimator.animateHeight(collapseRef.current, 'EngineCollapse' + Index, toggle)
   	},[toggle]);

	function handleCollapse(e){
			if (isExpanded !== null && expandedIndex !== null && Index !== null) {
				if (isExpanded === true) {
					setExpandedIndex(null);
				} else {
					setExpandedIndex(Index);
					setTimeout(()=>{
						const collapseTarget = e.target.closest('.mz-collapse');
						if(collapseTarget){
							const scrollWindow = document.querySelector('.mz-package-page__package-card-list');
							const topScroll = collapseTarget.offsetTop;
							scrollWindow.scroll({
							  top:topScroll,
							  behavior: 'smooth'
							});
						}
					},100);
				}
			} else{
				setToggle(!toggle);
			}
	}
    return (
        <div className={`mz-collapse engine-card ${Selected?'mz-collapse-selected engine-card-selected':''}`}>

            {modelData ?

				<div className="engine-card__content">
					<div
						onClick={handleCollapse}
						className="mz-collapse__button"
					>
						{Selected &&
							<div className="mz-check-indicator"><i className="mz-svg mz-svg--white mz-svg-checkmark"></i></div>
						}
		                <h6 className="engine-card__title">
							{modelData.drivetrain.short_description}<br/>
							{modelData.transmission.short_description}<br/>
							{modelData.engine.short_description}
						</h6>
						{engineCost != 0 ? ReactHtmlParser(`<p class="engine-card__price">${formatPrice(engineCost)} <span>
							${showFinancePrice?
							`(${getFinanceWeekly(engineCost, financial.calculatedFinance.financeValues[summaryCalculator.FinanceTermIndex].rate, financial.calculatedFinance.financeValues[summaryCalculator.FinanceTermIndex].term)}${t("general:week")})` : 
							!window.hideLeaseInCard ? `(${getLeaseBiWeeklyFromMsrp(engineCost, financial.calculatedLease.leaseValues[summaryCalculator.LeaseTermIndex].rate, financial.calculatedLease.leaseValues[summaryCalculator.LeaseTermIndex].term)}${t("general:bi_week")})` : ''
							}</span></p>`) : ''}
						<i className={`mz-svg mz-svg-chevron ${toggle ? 'mz-svg--rotate270':''}`}></i>
						<hr />
					</div>
					<div className="mz-collapse__box" ref={collapseRef}>

		                {!modelData.description ?
						<ul className="engine-card__list">
							<li className="engine-card__list-item">{ReactHtmlParser(modelData.drivetrain.label)}</li>
							<li className="engine-card__list-item">{ReactHtmlParser(modelData.transmission.label)}</li>
		                </ul> :
		                <p dangerouslySetInnerHTML={{ __html: modelData.description }} />}
					</div>
					<div>
		                {Selected ? <button className="mz-btn mz-button--secondary engine-card__select-button" disabled={true}><span>{t("general:button_selected")}</span></button> : <button className="mz-btn mz-btn--primary mz-btn--red engine-card__select-button" onClick={()=>{
							setSelectedModel(Index);
						}}><span>{t("select_engine")}</span></button>}
					</div>
            </div> : null}
        </div>
    )
}


export default EngineCard;

EngineCard.propTypes = {
    HandleSelectedModel: PropTypes.func,
}

EngineCard.defaultProps = {
    HandleSelectedModel: () => {},
};